/**
 * Calculates detailed tax bracket breakdown.
 *
 * @param {number} taxableIncome - The income on which tax should be calculated.
 * @param {Array} taxBands - Array of tax bands, where each band has a "breadth" and "rate".
 * @returns {Array} - An array of objects representing each tax bracket's details.
 */
export const calculateTaxFromBands= (taxableIncome, taxBands) => {
    // Safety check for invalid inputs
    if (!taxBands || !Array.isArray(taxBands) || taxBands.length === 0) {
      return { taxPaid: 0, bracketDetails: [] };
    }

    let tax = 0;
    let remainingIncome = taxableIncome;
    let taxBandBreakdown = [];

    for (let band of taxBands) {
      if (remainingIncome <= 0) break;
  
      /* tax */
      const bandBreadth = band.breadth === Infinity ? remainingIncome : band.breadth;
      const incomeInBand = Math.min(remainingIncome, bandBreadth);
      tax += incomeInBand * (band.rate / 100);
  
      /* taxBandBreakdown */
      const taxForBand = incomeInBand * (band.rate / 100);
      
      taxBandBreakdown.push({
        rate: band.rate,
        taxableAmount: incomeInBand,
        tax: taxForBand,
        takeHome: incomeInBand - taxForBand
      });
      
      remainingIncome -= incomeInBand;
    }
  
    return { taxPaid: tax, bracketDetails: taxBandBreakdown };
  }